import { useSearchParams } from 'hooks/useSearchParams';
import { isEmbedSubtype, type EmbedSubtype } from './embed';

const BLOCK_ID_PARAM = 'embedDialogBlockId';
const SUBTYPE_PARAM = 'embedDialogSubtype';

export function useEmbedDialogState(blockId: string) {
  const [searchParams, setSearchParams] = useSearchParams();

  const isOpenForThisBlock = searchParams.get(BLOCK_ID_PARAM) === blockId;
  const subtype = isOpenForThisBlock ? searchParams.get(SUBTYPE_PARAM) : null;
  const openSubtype = subtype && isEmbedSubtype(subtype) ? subtype : null;

  const openDialog = (nextSubtype: EmbedSubtype) => {
    setSearchParams((prev) => {
      prev.set(BLOCK_ID_PARAM, blockId);
      prev.set(SUBTYPE_PARAM, nextSubtype);
      return prev;
    });
  };

  const closeDialog = () => {
    setSearchParams(
      (prev) => {
        prev.delete(BLOCK_ID_PARAM);
        prev.delete(SUBTYPE_PARAM);
        return prev;
      },
      { replace: true }
    );
  };

  return { openSubtype, openDialog, closeDialog };
}
